import { render, staticRenderFns } from "./new-header.vue?vue&type=template&id=c2a0707c&"
import script from "./new-header.vue?vue&type=script&lang=js&"
export * from "./new-header.vue?vue&type=script&lang=js&"
import style0 from "./new-header.vue?vue&type=style&index=0&id=c2a0707c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports